import { useContext, useMemo } from 'react';

import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import type { ExtranetPackageItem } from 'app/typings/core/extranet/packages/packages';
import { BABY_COT_BED_CATEGORY_ID } from 'app/typings/rooms';

import type { Room } from '../ExtranetPackages.types';

export const usePackRooms = (selectedPack?: ExtranetPackageItem): Room[] => {
  const { getRoom } = useContext(ModernHotelContext);

  return useMemo(() => {
    if (!selectedPack) {
      return [];
    }

    return selectedPack.rooms.map((pr) => {
      const room = getRoom(pr.roomId);

      return {
        id: pr.roomId.toString(),
        name: pr.name ?? room?.categoryName ?? `Room #${pr.roomId}`,
        categoryName: room?.categoryName,
        images: room?.coverPicture ? [room.coverPicture] : undefined,
        beds: pr.beds.map((bed) => {
          const isBabyCot = bed.category.id === BABY_COT_BED_CATEGORY_ID;

          return {
            name: bed.category.name,
            categoryId: bed.category.id,
            isIncluded: bed.isIncluded,
            price: bed.price,
            capacity: {
              guest: isBabyCot ? 0 : bed.category.paxCapacity,
              baby: isBabyCot ? bed.category.paxCapacity : 0,
            },
          };
        }),
      };
    });
  }, [selectedPack, getRoom]);
};
